
class RTM {

	constructor() {
	    this.obj = null;
  	}

  	static instance = null;
    static createInstance = () => new RTM();

    static getInstance = () => {
        if (!RTM.instance) {
            RTM.instance = RTM.createInstance();
        }

        return RTM.instance;
    }

	registerHandler(callback) {
		this.obj = callback;
	}

	invoke(payload) {
		let cb = this.obj;
		cb(payload);
	}
}

export default RTM;